<style scoped>
    @import url("../../../styles/smartControl/cardEditRGP.scss");
</style>

<template>
    <div class="box_cardEditRGP mt-2">

        <v-dialog v-model="flagDialog" max-width="250px">
            <DialogMSG
                v-if="flagDialog && !flagLoading"
                :msgFromFather="msgFromFather"
                @fromDialogMsg="flagDialog = false"
            />
        </v-dialog>

        <div
            v-if="flagLoading"
            class="mb-16 mt-16"
            style="display: flex; width: 100%; align-items: center; justify-content: center;"
        >
            <v-progress-circular
                color="black"
                size="64"
                indeterminate
            />
        </div>

        <div class="linhaZero" v-if="!flagDialog && !flagLoading">
            <v-chip class="ml-1" size="x-small" color="white">
                {{ 'Programa (' + currentProgram.program + ') em edição' }}
            </v-chip>
            <v-icon class="ml-1" size="32">mdi-pen</v-icon>
        </div>

        <div class="linhaUm mt-4" v-if="!flagDialog && !flagLoading">
            <div class="colUm">

                <div class="linhaForm">
                    <span class="tLinha">Nome do programa</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div class="elInput">
                        <v-text-field
                            v-model="currentProgram.name"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div class="linhaForm">
                    <span class="tLinha">active</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div class="elSelect">
                        <v-select
                            v-model="currentProgram.active"
                            :items="booleanOptions"
                            item-title="title"
                            item-value="value"
                            class="w-100"
                            color="#1F7AB1"
                            variant="plain"
                            bg-color="transparent"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div class="linhaForm">
                    <span class="tLinha">fertilicerFormula</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div class="elInput">
                        <v-text-field
                            v-model="currentProgram.fertilicerFormula"
                            type="text"
                            inputmode="numeric"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div class="linhaForm">
                    <span class="tLinha">groups</span>
                    <v-divider vertical class="mx-1" style="height: 30px;" />

                    <div style="display: flex; flex-direction: column; flex: 1; min-width: 0;">
                        <div class="d-flex flex-wrap">
                            <v-chip
                                v-for="(group, index) in currentProgram.groups"
                                :key="index"
                                class="ma-1"
                                size="small"
                                closable
                                @click:close="removeGroup(index)"
                            >
                                {{ 'Grupo ' + group }}
                            </v-chip>
                        </div>

                        <div class="elSelect">
                            <v-autocomplete
                                v-model="selectedGroup"
                                :items="availableGroups"
                                class="w-100"
                                color="#1F7AB1"
                                variant="plain"
                                bg-color="transparent"
                                density="compact"
                                hide-details
                                placeholder="Adicionar grupo"
                                @update:modelValue="addGroup($event)"
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <v-btn
            v-if="flagBtnEnd && !flagDialog && !flagLoading"
            @click="sendInfo()"
            style="color: green;"
        >
            <span class="txt_btn_irrig">Atualizar</span>
        </v-btn>

        <span v-if="flagMSG" class="txt_btn_irrig">{{ msg }}</span>

    </div>
</template>

<script>
import axios from 'axios'
import DialogMSG from './DialogMSG.vue'

export default {
    props: ['program', 'tok'],

    components: { DialogMSG },

    data() {
        return {
            currentProgram: null,
            originalProgram: null,

            selectedGroup: null,
            groupsOptions2select: [],

            booleanOptions: [
                { title: 'Ativado', value: true },
                { title: 'Desativado', value: false }
            ],

            flagBtnEnd: false,
            flagLoading: false,
            flagDialog: false,
            flagMSG: false,
            msg: '',
            msgFromFather: ''
        }
    },

    computed: {
        availableGroups() {
            let available = []

            for (const group of this.groupsOptions2select) {
                if (!this.currentProgram.groups.includes(group)) {
                    available.push(group)
                }
            }

            return available
        }
    },

    methods: {
        addGroup(group) {
            if (!Number.isInteger(group) || group < 0 || group > 98) {
                return
            }

            if (!this.currentProgram.groups.includes(group)) {
                this.currentProgram.groups.push(group)
                this.changeInfo()
            }

            this.$nextTick(() => {
                this.selectedGroup = null
            })
        },

        removeGroup(index) {
            this.currentProgram.groups.splice(index, 1)
            this.changeInfo()
        },

        getUpdates() {
            let updates = {}

            if (this.currentProgram.name !== this.originalProgram.name) {
                updates.name = this.currentProgram.name
            }

            if (typeof this.currentProgram.active !== 'boolean') {
                throw new Error('Selecione o estado de active')
            }

            if (this.currentProgram.active !== this.originalProgram.active) {
                updates.active = this.currentProgram.active
            }

            let formula = this.currentProgram.fertilicerFormula
            let originalFormula = this.originalProgram.fertilicerFormula

            if (formula == null || String(formula).trim() === '') {
                throw new Error('Preencha fertilicerFormula')
            }

            formula = Number(String(formula).replace(',', '.'))

            if (
                !Number.isInteger(formula) ||
                !((formula >= 0 && formula <= 29) || formula === 255)
            ) {
                throw new Error('fertilicerFormula deve ser de 0 a 29 ou 255')
            }

            if (
                originalFormula != null &&
                String(originalFormula).trim() !== ''
            ) {
                originalFormula = Number(
                    String(originalFormula).replace(',', '.')
                )
            }

            if (formula !== originalFormula) {
                updates.fertilicerFormula = formula
            }

            const groups = this.currentProgram.groups

            if (!Array.isArray(groups)) {
                throw new Error('groups deve ser uma lista')
            }

            for (const group of groups) {
                if (
                    !Number.isInteger(group) ||
                    group < 0 ||
                    group > 98
                ) {
                    throw new Error('groups deve conter inteiros de 0 a 98')
                }
            }

            if (
                JSON.stringify(groups) !==
                JSON.stringify(this.originalProgram.groups)
            ) {
                updates.groups = [...groups]
            }

            return updates
        },

        changeInfo() {
            this.flagMSG = false

            try {
                this.flagBtnEnd = Object.keys(this.getUpdates()).length > 0
            } catch (e) {
                this.flagBtnEnd = false
                this.msg = e.message
                this.flagMSG = true
            }
        },

        async sendInfo() {
            let updates

            try {
                updates = this.getUpdates()
            } catch (e) {
                this.msg = e.message
                this.flagMSG = true
                return
            }

            if (Object.keys(updates).length === 0) {
                this.msg = 'Nenhuma alteração identificada'
                this.flagMSG = true
                this.flagBtnEnd = false
                return
            }

            this.flagMSG = false
            this.flagLoading = true

            try {
                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Xilema-Auth': `Bearer ${this.tok}`,
                    'Content-Type': 'application/json'
                }

                const params = {
                    program_id: this.currentProgram.program,
                    updates: updates
                }

                const rota =
                    this.$store.state.pathAxiosBASE + '/postxprogramxbyxid'

                const res = await axios.post(rota, params, { headers })
                const rcv = res.data.result ?? res.data

                console.log('rcv:', rcv)

                if (rcv.error === false) {
                    for (const key of Object.keys(updates)) {
                        this.currentProgram[key] = updates[key]
                    }

                    this.originalProgram = JSON.parse(
                        JSON.stringify(this.currentProgram)
                    )

                    this.msgFromFather = 'Atualizado.' // <-- dialog component | 'Atualização aceite.'
                    this.flagBtnEnd = false
                } else {
                    this.msgFromFather = 'Não foi possível atualizar. Tente novamente mais tarde.'
                }
            } catch (e) {
                console.log('[sendInfo] erro:', e.response?.data ?? e.message)

                this.msgFromFather =
                    'Não foi possível atualizar. Tente novamente mais tarde.'
            } finally {
                this.flagLoading = false
                this.flagDialog = true
            }
        }
    },

    created() {
        this.currentProgram = JSON.parse(JSON.stringify(this.program))
        this.originalProgram = JSON.parse(JSON.stringify(this.program))

        for (let i = 0; i <= 98; i++) {
            this.groupsOptions2select.push(i)
        }
    }
}
</script>
